import React from "react";

function Contact() {
  return (
    <div className="container py-5">
      <div className="text-center mb-5">
        <h1 className="display-4 fw-bold">📞 Contact Us</h1>
        <p className="lead text-muted">
          Got questions? We'd love to hear from you.
        </p>
      </div>

      <div className="row mb-5">
        <div className="col-md-6">
          <h3 className="fw-bold mb-4">Send us a message</h3>
          <form>
            <div className="mb-3">
              <label className="form-label">Full Name</label>
              <input type="text" className="form-control" placeholder="Enter your name" required />
            </div>
            <div className="mb-3">
              <label className="form-label">Email Address</label>
              <input type="email" className="form-control" placeholder="Enter your email" required />
            </div>
            <div className="mb-3">
              <label className="form-label">Message</label>
              <textarea className="form-control" rows="4" placeholder="How can we help?" required></textarea>
            </div>
            <button type="submit" className="btn btn-dark w-100">Send Message</button>
          </form>
        </div>

        <div className="col-md-6">
          <h3 className="fw-bold mb-4">📍 Our Location</h3>
          <div className="ratio ratio-4x3 shadow rounded">
            <iframe
              title="Dream Rent Cars Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.2319954564083!2d-122.41941508468174!3d37.774929779758226!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808f7e4e2f74e33f%3A0x7e5e2cb2c145e85e!2sSan%20Francisco!5e0!3m2!1sen!2sin!4v1616584812345!5m2!1sen!2sin"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              style={{ border: 0 }}
            ></iframe>
          </div>
        </div>
      </div>

      <div className="bg-dark text-white p-4 rounded">
        <div className="row text-center">
          <div className="col-md-4 mb-3 mb-md-0">
            <h5>📧 Email</h5>
            <p>support@dreamrentcars.com</p>
          </div>
          <div className="col-md-4 mb-3 mb-md-0">
            <h5>📞 Phone</h5>
            <p>+91 98765 43210</p>
          </div>
          <div className="col-md-4">
            <h5>📍 Address</h5>
            <p>123 Luxury Lane, Mumbai, India</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
